import { css } from '@compiled/react';

import SearchIcon from '@atlaskit/icon/core/search';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

type JsmPlaygroundSearchFieldProps = {
	label: string;
	placeholder: string;
	tabIndex?: number;
};

export const JsmPlaygroundSearchField = ({
	label,
	placeholder,
	tabIndex,
}: JsmPlaygroundSearchFieldProps) => (
	<div css={searchFieldWrapperStyles}>
		<Textfield
			aria-label={label}
			appearance="none"
			elemBeforeInput={
				<span css={searchIconWrapperStyles}>
					<SearchIcon color={token('color.icon.subtle')} label="" size="small" />
				</span>
			}
			isCompact
			isReadOnly
			placeholder={placeholder}
			tabIndex={tabIndex}
		/>
	</div>
);

const searchFieldWrapperStyles = css({
	display: 'flex',
	boxSizing: 'border-box',
	width: '100%',
	minWidth: 0,
	flex: '1 1 auto',
	paddingBlockStart: token('border.width', '1px'),
	paddingBlockEnd: token('border.width', '1px'),
	borderWidth: token('border.width', '1px'),
	borderStyle: 'solid',
	borderColor: token('color.border.input'),
	borderRadius: token('radius.medium', '6px'),
	backgroundColor: token('color.background.input'),
	overflow: 'hidden',
});

const searchIconWrapperStyles = css({
	display: 'inline-flex',
	paddingInlineStart: token('space.075'),
});
